import { Component } from '@angular/core';
import MessagesActionsService from '../../utils/services/messages-actions.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { slideInOut } from '../../utils/animations/slides.animation';
import AccessoriesService from '../../cart-process/accessories.service';
import { CommonInfoService } from '../../cart-process/common-info.service';

@Component({
  selector: 'new-offer-slot-accessories',
  templateUrl: './new-offer-slot-accessories.component.html',
  animations: [slideInOut]
})
export default class NewOfferSlotAccessoriesComponent {
  public showHeader: boolean = false;

  constructor(
    public accessoriesService: AccessoriesService,
    private messagesActionsService: MessagesActionsService,
    private notificationProvider: NotificationProviderService,
  ) {
    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.COMMON_INFO,
      (commonInfoService: CommonInfoService) => {
        if (!commonInfoService) {
          return;
        }

        this.showHeader = !commonInfoService.isOtherSalesOffer;
      }
    );
  }
}

